import {
  FiBarChart2, FiBell, FiBriefcase, FiCalendar, FiCheckSquare, FiCircle, FiClipboard, FiClock,
  FiDollarSign, FiFileText, FiGift, FiGrid, FiHelpCircle, FiHome, FiInbox, FiMessageSquare,
  FiRepeat, FiSettings, FiShoppingBag, FiTrendingUp, FiUser, FiUserCheck, FiUserPlus, FiUsers, FiHome as FiRealEstate,
} from "react-icons/fi";
import { isComingSoon, isPathMatch } from "./menuModel";

// One consistent icon set, chosen by path so the menu data itself stays untouched.
const BY_PREFIX = [
  ["/super_admin/dashboard", FiGrid],
  ["/member/dashboard", FiHome],
  ["/invest/dashboard", FiTrendingUp],
  ["/super_admin/audit_log", FiClipboard],
  ["/super_admin/settings", FiSettings],
  ["/super_admin/member_management", FiUsers],
  ["/super_admin/staff_registration", FiUserCheck],
  ["/super_admin/contribution", FiDollarSign],
  ["/member/contribution", FiDollarSign],
  ["/super_admin/loan_management", FiBriefcase],
  ["/member/loan_management", FiBriefcase],
  ["/super_admin/investor_portal/marketplace", FiShoppingBag],
  ["/invest/marketplace", FiShoppingBag],
  ["/super_admin/investor_portal/investments", FiTrendingUp],
  ["/invest/investments", FiTrendingUp],
  ["/super_admin/investor_portal/investors", FiUserPlus],
  ["/super_admin/investor_portal/real_estate", FiRealEstate],
  ["/super_admin/communication", FiMessageSquare],
  ["/member/communication", FiMessageSquare],
  ["/super_admin/event_calendar", FiCalendar],
  ["/member/event", FiCalendar],
  ["/super_admin/attendance", FiCheckSquare],
  ["/member/attendance", FiCheckSquare],
  ["/super_admin/automated_birthday", FiGift],
  ["/member/birthdays", FiGift],
  ["/super_admin/eminutes", FiFileText],
  ["/member/eminutes", FiFileText],
  ["/super_admin/reports", FiBarChart2],
  ["/super_admin/transaction_history", FiRepeat],
  ["/member/transaction_history", FiRepeat],
  ["/super_admin/admin", FiHelpCircle],
  ["/member/support", FiHelpCircle],
  ["/invest/requests", FiInbox],
  ["/invest/profile", FiUser],
  ["/invest/notifications", FiBell],
];

export function iconFor(item) {
  if (isComingSoon(item)) return FiClock;
  const hit = BY_PREFIX.find(([prefix]) => isPathMatch(item?.path, prefix));
  return hit ? hit[1] : FiCircle;
}
